import { render, staticRenderFns } from "./index.view.vue?vue&type=template&id=3962dd22&"
import script from "./index.view.ts?vue&type=script&lang=ts&"
export * from "./index.view.ts?vue&type=script&lang=ts&"
import style0 from "./index.view.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports